import { CrudConfig, handleIPTypeChange } from '@src/model/table';
import { useStores } from '@src/components/store';
import { Address } from '@src/dtos/version.dto';
import { AddressIPType, AddressType } from '@src/utils/enums';
import { isDuplicate } from '@src/utils/validationUtils';
import { MAX_BRONZE_IP_ADDRESSES } from '@src/utils/constants';

const ipListDataChangesHandler = {
    set: (obj: any, prop: string, value: any) => {
        handleIPTypeChange(obj, prop, value);
        obj[prop] = value;
        return true;
    }
};

export const useIpListCrudConfig = (): CrudConfig<Address> => {
    const { fwVersionBronzeStore } = useStores();
    return {
        createNewText: 'Add IP Address',
        buttonClass: 'link-btn',
        displayInlineActions: fwVersionBronzeStore.isSelectedBronzeVersionEditable,
        disableEditReason: fwVersionBronzeStore.bronzeDisableReason,
        newRecord: {
            value: '',
            description: '',
            id: '',
            displayName: '',
            type: AddressType.IPV4_NETMASK,
            ipType: AddressIPType.IP_NETMASK
        },
        rowLimit: MAX_BRONZE_IP_ADDRESSES,
        isDuplicated: (record: Address, originalRecord: Address | undefined, keys: string[]): boolean => {
            return isDuplicate(record, originalRecord, fwVersionBronzeStore.getAddresses, keys);
        },
        saveCb: (data: Address) => fwVersionBronzeStore.addAddress(data),
        updateCb: (updatedRecord: Address, originalRecord: Address) =>
            fwVersionBronzeStore.updateAddress(updatedRecord, originalRecord),
        removeCb: (data: Address) => fwVersionBronzeStore.removeAddress(data),
        dataChangesHandler: ipListDataChangesHandler,
        entityName: `IP address`,
        modalWidth: 640
    };
};
